// removed by extract-text-webpack-plugin
module.exports = {"preview":"preview","dashboard-chart-list":"dashboard-chart-list","report-charts":"report-charts","ant-col-12":"ant-col-12","wrapper-box":"wrapper-box","ant-pagination-item-active":"ant-pagination-item-active"};


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/preview/dashboard/index.scss
// module id = 1436
// module chunks = 0